<template>
  <div v-title data-title="设置">
    <!--<wv-switch title="是否开放注册" v-if="IsOpenRegistration!=undefined&&userType==4" v-model="IsOpenRegistration" @change="changeIsOpenRegistration()"></wv-switch>-->
    <wv-panel title>
      <wv-cell title="收货地址" is-link to="/page/deliveryaddress">
        <img
          src="../../assets/img/user.png"
          alt
          slot="icon"
          class="cell-icon"
          style="margin-top:6px;width:20px"
        />
      </wv-cell>
      <wv-cell title="身份认证" is-link to="/page/messageset">
        <img
          src="../../assets/img/user.png"
          alt
          slot="icon"
          class="cell-icon"
          style="margin-top:6px;width:20px"
        />
      </wv-cell>
      <wv-cell title="重置密码" v-if="userType==4" is-link @click="forgetpassword()">
        <img
          src="../../assets/img/resetpassword.png"
          alt
          slot="icon"
          class="cell-icon"
          style="margin-top:6px;width:20px"
        />
      </wv-cell>
      <wv-cell title="设置" v-if="false" is-link to="/page/setlist">
        <img
          src="../../assets/img/legal.png"
          alt
          slot="icon"
          class="cell-icon"
          style="margin-top:6px;width:20px"
        />
      </wv-cell>
      <wv-cell title="退出" is-link @click="logout()">
        <img
          src="../../assets/img/logout.png"
          alt
          slot="icon"
          class="cell-icon"
          style="margin-top:6px;width:20px"
        />
      </wv-cell>
    </wv-panel>
  </div>
</template>

<script>
import thumb from "../../assets/logo.png";
import { Dialog, Toast } from "we-vue";
export default {
  name: "myset",
  data: function() {
    return {
      logourl: thumb,
      reallogourl: "log",
      title: "",
      description: "",
      orderTotal: "",
      ForwardCount: "",
      Amount: 0,
      userType: -1,
      IsOpenRegistration: undefined
    };
  },
  created: function() {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }
    this.InitPersonalInfo();
  },
  methods: {
    forgetpassword: function() {
      this.$router.push("/page/passwordset?logintype=" + this.userType);
    },
    InitPersonalInfo: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/dispersonalinfo", {})
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.title = rep.Data.Name;
              this.description = rep.Data.SysCompanyName;
              this.orderTotal = rep.Data.OrderTotal;
              this.ForwardCount = rep.Data.ForwardCount;
              this.Amount = rep.Data.Amount;
              this.reallogourl = rep.Data.LogoUrl;
              this.userType = rep.Data.Type;
              this.IsOpenRegistration = rep.Data.IsOpenRegistration;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    logout: function() {
      Dialog.confirm({
        title: "消息提醒",
        message: "是否确认退出?",
        skin: "ios",
        showCancelButton: true
      })
        .then(() => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("loginType");
          // localStorage.removeItem("disid");
          localStorage.clear();
          if (this.userType == 4) {
            this.$router.push("/account/login?type=dis");
          } else {
            this.$router.push("/account/login");
          }
        })
        .catch(() => {});
    },
    ToOrderPage: function(ordertype) {
      this.$router.push({
        path: "/app/order",
        query: {
          ordertype: ordertype
        }
      });
    },
    changeIsOpenRegistration: function() {
      if (this.IsOpenRegistration != undefined) {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/changeIsOpenRegistration", {
            params: {
              isOpenRegistration: this.IsOpenRegistration
            }
          })
          .then(
            function(d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
              } else {
                Toast.fail(rep.Message);
              }
            },
            function(d) {
              console.log(d);
            }
          );
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/my/myset.vue